
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import { EnumMyCenterPrivacyConfig } from '@xt/client/enums/my'
import LazyImg from '@/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg,
    HeaderImage
  }
})
export default class UserPanel extends Vue {
  @Prop({ required: true }) memberId: string
  @Prop({ default: false }) isSelf: boolean
  @Prop({ default: false }) hideExperice: boolean

  get EnumMyCenterPrivacyConfig() {
    return EnumMyCenterPrivacyConfig
  }

  get CenterStore() {
    return this.$store.$myV2.Center
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  async toggleFollow(memberId: string) {
    this.CenterStore.toggleFollow(memberId)
  }

  copyUserId() {
    const disappear = 'position: fixed;z-index: -2;top: -100px'
    let input = document.createElement('input')
    input.value = this.UserInfo.userName
    input.setAttribute('style', disappear)
    document.body.appendChild(input)
    input.focus()
    input.select()
    if (document.execCommand('copy', false, undefined)) {
      //success info
      this.$msg('复制成功', 'success')
    } else {
      this.$msg('请手动复制ID号')
    }
    document.body.removeChild(input)
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
